import Api from '@/services/Api'

export default {
    getUpdates() {
        return Api().get('/history')
    }
}
